import { apiClient } from "@/api";
import { TResponse } from "./chat-service";
import type { AxiosRequestConfig } from "axios";

export interface ShortlistAgent {
  agent_id: string;
  name: string;
  short_description: string;
  solution: string;
  provider: string;
  categories: string | null;
  application_area: string;
  selected_count: number;
  score: number;
  status: "active" | "inactive";
  main_category?: string | null;
}

interface ShortlistRes {
  target_pid: string;
  target_name: string;
  matches: ShortlistAgent[];
}

export const getShortlist = (projectId: string, config?: AxiosRequestConfig) => {
  return apiClient.get<TResponse<ShortlistRes>>(`/match-agents/${projectId}`, config);
};

interface InquiryReq {
  title: string;
  content: string;
  agent_ids?: string[];
  project_id?: string;
}

interface InquiryRes {
  id: string;
  user_id: string;
  title: string;
  content: string;
  status: string;
  admin_id: string;
  created_at: string;
  updated_at: string;
}

// 옛 숏리스트 문의 API는 새 IA에서 폐기되어 서버에 없어요(결정 D28 · 옛 코드 삭제). 호출은 실패하고, 화면이 오류 안내를 띄워요.
// 전역 /404 화면으로 보내지 않도록 404 이동을 끕니다. 새 문의는 Contact Us(`/contact`)로 대체.
export const requestCustomAgent = (req: InquiryReq, config?: AxiosRequestConfig) => {
  return apiClient.post<TResponse<InquiryRes>>("/inquiries/", req, { skipNotFoundRedirect: true, ...config });
};

// export const inviteToCompare = (projectId: string, agentIds: string[]) => {
//   return apiClient.post(`/projects/${projectId}/shortlist/invite`, {
//     agent_ids: agentIds,
//   });
// };
